module.exports = __webpack_public_path__ + "img/mind-map.abdb2887.png";